import { render } from "./exchangeSucc.vue?vue&type=template&id=0bd5d7f0"
import script from "./exchangeSucc.vue?vue&type=script&lang=js"
export * from "./exchangeSucc.vue?vue&type=script&lang=js"

import "./exchangeSucc.vue?vue&type=style&index=0&id=0bd5d7f0&lang=scss"

import exportComponent from "/Users/wanggaochao/项目/善城 (2)/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__